module.exports = __webpack_public_path__ + "media/images/logo_re-ism-583db04d08cb23f40c67f8089367bac0.png";